import { DriverMileageDto } from "../entities/dtos/driver-mileage.dto";
import {
  CsvColumn,
  CsvTranslator,
  formatCsvDate,
  formatCsvKilometers,
  withKilometreUnit
} from "app/data/helpers/csvExportHelpers";

/**
 * CSV shape of the Chauffeur Kilometers overview.
 *
 * Kept apart from `DRIVER_MILEAGE_TABLE_COLUMNS` for the same reason as on the
 * Keys page: those cells render badges and `N/A`, and neither belongs in the
 * file. The row number column is left out because it numbers the screen, not
 * the data.
 *
 * Headers read from the same `tableHeading.*` keys the table renders, so a
 * column is captioned in the file exactly as it is on screen, in whichever
 * language the user has selected.
 */
export const DRIVER_MILEAGE_CSV_COLUMNS = (
  translator: CsvTranslator
): CsvColumn<DriverMileageDto>[] => {
  const heading = (key: string) =>
    translator(`tableHeading.${key}`, { ns: "tableHeadingsTranslation" });

  return [
    {
      header: heading("driverName"),
      value: (row) =>
        [row?.driver?.firstName, row?.driver?.lastName]
          .filter(Boolean)
          .join(" ")
          .trim()
    },
    {
      header: heading("driverEmail"),
      value: (row) => row?.driver?.email
    },
    {
      header: heading("year"),
      value: (row) => row?.year
    },
    {
      header: withKilometreUnit(heading("totalMileage")),
      value: (row) => formatCsvKilometers(row?.totalKilometers)
    },
    {
      header: heading("lastNotificated"),
      value: (row) => formatCsvDate(row?.lastNotificated)
    }
  ];
};
